import { Injectable, EventEmitter } from '@angular/core'
import PouchDB from 'pouchdb';

@Injectable({
    providedIn: 'root'
})
export class CouchPromocionesService {

    private isInstantiated: boolean;
    private database: any;
    private listener: EventEmitter<any> = new EventEmitter();
    private elementRem: EventEmitter<any> = new EventEmitter();

    constructor() {
        if (!this.isInstantiated) {
            sIdkatios = this.GetIdKatiosLVL1FromSession();
            this.database = new PouchDB("promociones_" + sIdkatios, { auto_compaction: true });
            var sIdkatios: string;

            //this.sync(this.GetServer(sIdkatios));
            this.isInstantiated = true;
            console.log("********************************** INSTANCE PROMOCIONES *****************************************")
        }
    }

    public GetServer(sIdkatios): string {
        //var json = require('../../../assets/Config/config.json');
        var json = require('G:/Desarrollo/BD/WE8/config.json');
        return json.CouchDBM3 + "promociones_" + sIdkatios.toLowerCase();
    }

    //Idkatios que se carga, cuando se inicia el redireccionamiento hacia el WE8
    public GetIdKatiosLVL1FromSession() {
        var sSessionLVL1M3 = sessionStorage.getItem("SessionLVL1M3");
        var oSessionLVL1M3;
        if (sSessionLVL1M3 !== undefined && sSessionLVL1M3 != null) {
            oSessionLVL1M3 = JSON.parse(sSessionLVL1M3);
            if (oSessionLVL1M3.UsuarioSistema.IDKATIOS !== undefined && oSessionLVL1M3.UsuarioSistema.IDKATIOS != null) {
                return oSessionLVL1M3.UsuarioSistema.IDKATIOS;
            }
        }
        return null;
    }

    public sync(remote: string) {
        let remoteDatabase = new PouchDB(remote, { auto_compaction: true });

        this.database.replicate.from(remoteDatabase, {
            live: true,
            retry: true
        }).on('complete', change => {
            console.log(change);
            console.log("********************************** COMPLETO CAMBIO PROMOCIONES *****************************************")
        }).on('change', change => {
            console.log(change);
            this.listener.emit(change);
            console.log("********************************** CHANGE CAMBIO PROMOCIONES *****************************************")
        }).on('error', function (err) {
            console.log("Error")
            console.log(err)
            // boo, something went wrong!
        });
    }

    public syncWithDB(remoteDatabase: PouchDB) {

        this.database.replicate.from(remoteDatabase, {
            live: true,
            retry: true
        }).on('complete', change => {
            console.log(change);
            console.log("********************************** COMPLETO CAMBIO PROMOCIONES *****************************************")
        }).on('change', change => {
            console.log(change);
            this.listener.emit(change);
            console.log("********************************** CHANGE CAMBIO PROMOCIONES *****************************************")
        }).on('error', function (err) {
            console.log("Error")
            console.log(err)
            // boo, something went wrong!
        });
    }


    public async syncAwait(remote: string) {
        let remoteDatabase = new PouchDB(remote, { auto_compaction: true });

        await this.database.replicate.from(remoteDatabase, {
        }).on('complete', change => {

            console.log(change);
            console.log("********************************** COMPLETO CAMBIO PROMOCIONES *****************************************")
            this.syncWithDB(remoteDatabase);
        }).on('error', function (err) {
            console.log("Error")
            console.log(err)
            // boo, something went wrong!
        });

        await this.database.compact();
    }

    // public changes(remote: string){
    //     let remoteDatabase = new PouchDB(remote);
    //     remoteDatabase.changes({
    //         since: 'now',
    //         live: true,
    //         include_docs: true
    //       }).on('change', function (change) {
    //         // change.id contains the doc id, change.doc contains the doc
    //         if (change.deleted) {
    //           // document was deleted
    //         } else {
    //           // document was added/modified
    //         }
    //       }).on('error', function (err) {
    //         // handle errors
    //       });
    // }


    public get(id: string) {
        return this.database.get(id);
    }

    public delete(id: string) {
        this.database.get(id).then(doc =>{
            return this.database.remove(doc);
        });
    }

    public fetch() {
        return this.database.allDocs({ include_docs: true });
    }

    public getEncabezado() {
        return this.database.allDocs({ include_docs: false });
    }

    public getChangeListener() {
        return this.listener;
    }

    public elementRemoved() {
        this.database.changes({ live: true, since: 'now', include_docs: true })
        .on('change', change => {
            if (change.deleted) {
                console.log(change);
                this.elementRem.emit(change);
            }
            //renderDocsSomehow();
        }).on('error', console.log.bind(console));
    }

    public getRemoveListener() {
        return this.elementRem;
    }


}